<template>
  <div class="chart">
    <canvas :id="id" class="chart-canvas" :height="height"></canvas>
  </div>
</template>

<script>
import Chart from "chart.js/auto";
import { markRaw } from "vue";
import ChartDataLabels from 'chartjs-plugin-datalabels';

export default {
  name: "bar-chart",
  props: {
    id: { type: String, default: "bar-chart" },
    height: { type: [String, Number], default: "300" },
    chart: { type: Object, required: true },
  },
  data() {
    return {
      instance: null,
    };
  },
  watch: {
    chart: {
      handler(newData) {
        if (this.instance) {
          this.instance.data.labels = newData.labels;
          this.instance.data.datasets = newData.datasets;
          // Si envías opciones nuevas (como las de datalabels), las actualizamos
          if (newData.options) {
            this.instance.options = { ...this.instance.options, ...newData.options };
          }
          this.instance.update();
        }
      },
      deep: true,
    },
  },
  mounted() {
    const ctx = document.getElementById(this.id).getContext("2d");

    this.instance = markRaw(
      new Chart(ctx, {
        type: "bar",
        // REGISTRAMOS EL PLUGIN AQUÍ
        plugins: [ChartDataLabels],
        data: {
          labels: this.chart.labels,
          datasets: this.chart.datasets,
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          // Combinamos opciones por defecto con las que vengan del padre
          ...(this.chart.options || {}),
          plugins: {
            // Configuraciones por defecto para las etiquetas
            datalabels: {
              anchor: 'end',
              align: 'top',
              color: '#444',
              font: { weight: 'bold' },
              ...(this.chart.options?.plugins?.datalabels || {})
            },
            ...this.chart.options?.plugins
          }
        },
      })
    );
  },
  beforeUnmount() {
    if (this.instance) {
      this.instance.destroy();
    }
  },
};
</script>